import React from 'react'
import PropTypes from 'prop-types'
import Sprite from '~components/Sprite'
import Button from '~components/ui/Button'
import parse from 'html-react-parser'

const Modal = ({ title, text, buttonText = 'Confirm', onClose, onConfirm }) => {
  return (
    <div className="fixed top-0 bottom-0 left-0 right-0 flex flex-col p-4 bg-opacity-75 z-60 md:p-8 bg-charcoal">
      <div className="relative w-full px-4 py-8 m-auto overflow-x-hidden overflow-y-auto bg-white sm:bg-lightGrey max-w-screen-mdxl sm:p-15 sm:pb-0 overflow-scrolling">
        <button type="button" className="absolute block w-10 h-10 top-3 right-1 sm:top-8 sm:right-7" aria-label="Close" onClick={onClose}>
          <span className="block w-4 h-4 m-auto icon icon-fill" aria-hidden="true">
            <Sprite name="cross" />
          </span>
        </button>

        <h3 className="pb-6 pr-6 border-b text-md lg:text-2xl border-coral">
          {title}
        </h3>

        {text && (
          <div className="w-full mt-7 editor editor-standard">
            {parse(text)}
          </div>
        )}

        <div className="relative flex flex-wrap mt-12 sm:bg-white sm:py-8 before:bg-white after:bg-white before:-left-max after:-right-max content-after content-before sm:content-before sm:content-after before:absolute after:absolute before:w-max after:w-max before:top-0 after:top-0 before:h-full after:h-full" tw-content-before="" tw-content-after="">
          <Button
            onClick={onConfirm}
            theme="green-to-pink"
            className="w-full"
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  className: PropTypes.string
}

export default Modal
